import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import main from './main';

const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    main: main
});

export default reducers;